import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilService } from './../../../../../shared/_services/util.service';
import { HcaManagementService } from '../../../../../shared/_services/hca-management.service';
@Component({
  selector: 'app-hca-general',
  templateUrl: './hca-general.component.html',
  styleUrls: ['./hca-general.component.scss']
})
export class HcaGeneralComponent implements OnInit {
  settings: FormGroup;
  languages = [{'name': 'English', 'code': 'en'}];
  selectedLanguage = this.languages[0];
  permissionSettings: FormGroup;
  loginSuccessMsg: string;
  loginErrorMsg: string;

  constructor(
    private fb: FormBuilder,
    private utilService: UtilService,
    private hcaManagementService: HcaManagementService
  ) {
  }

  updateLoginAccess(value) {
    this.hcaManagementService.updateLoginAccess(value).subscribe(res => {
      if(res.error == 0) {
        this.loginSuccessMsg = 'Login Access Permissions updated successfully';
        setTimeout(() => {
          this.loginSuccessMsg = '';
        }, 1500);
      } else {
        this.loginErrorMsg = 'Error while updating Login Access Permissions';
        setTimeout(() => {
          this.loginErrorMsg = '';
        }, 1500);
      }
    }, err => {
      this.loginErrorMsg = err && err.message ? err.message : 'Error while updating Login Access Permissions';
      setTimeout(() => {
        this.loginErrorMsg = '';
      }, 1500);
    })
  }

  getLoginAccess() {
    this.hcaManagementService.getLoginAccess().subscribe(res => {
      if(res.error == 0) {
        this.initAccessForm(res.responseObj);
      }
    })
  }

  initAccessForm(data?) {
    this.permissionSettings = this.fb.group({
      isAllowAccess: [data ? data.isAllowAccess : false]
    });
    this.permissionSettings.valueChanges.subscribe(value => {
      this.loginSuccessMsg = "";
      this.loginErrorMsg = "";
      this.updateLoginAccess(value.isAllowAccess);
    });
  }


  ngOnInit() {
    this.getLoginAccess();
    this.initAccessForm();
    this.settings = this.fb.group({
      selectedLang: ['']
    });
    this.setLanguage(this.selectedLanguage.code);
    this.settings.valueChanges.subscribe(data => {
      this.utilService.translateLang(data.selectedLang);
    });
  }

  setLanguage(langCode) {
    this.settings.setValue({ selectedLang: langCode });
  }
  onChange(lang) {
    console.log(lang);
    //this.utilService.translateLang(lang.code);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-general/hca-general.component.ts